import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { BsSun, BsMoon } from "react-icons/bs";
import { FiMenu, FiX } from "react-icons/fi";

const Header = ({ toggleDarkMode, darkMode }) => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [isVisible, setIsVisible] = useState(true);
  const [lastScrollY, setLastScrollY] = useState(0);

  // Detect Scroll Direction (Hide Navbar on Scroll Down, Show on Scroll Up)
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > lastScrollY && window.scrollY > 80) {
        setIsVisible(false); // Hide Navbar when scrolling down
      } else {
        setIsVisible(true); // Show Navbar when scrolling up
      }
      setLastScrollY(window.scrollY);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [lastScrollY]);

  return (
    <motion.nav
      className={`fixed top-0 left-0 w-full z-50 px-6 py-3 flex items-center justify-between transition-all duration-300 ${
        isVisible ? "translate-y-0 opacity-100" : "-translate-y-full opacity-0"
      }`}
      initial={{ opacity: 1 }}
      animate={{ opacity: isVisible ? 1 : 0 }}
      transition={{ duration: 0.3 }}
    >
      {/* Logo (Clickable to Homepage) */}
      <Link to="/" className="flex items-center">
        <img src="/assets/kuralogo.svg" alt="Kura Digital Logo" className="h-10" />
      </Link>

      {/* Desktop Navigation Links (with Grey Color in Light Mode) */}
      <nav className="hidden md:flex gap-x-6 text-gray-700 dark:text-white">
        <Link to="/our-process" className="hover:text-gray-500 transition">Our Process</Link>
        <Link to="/services/websites" className="hover:text-gray-500 transition">Websites</Link>
        <Link to="/services/software" className="hover:text-gray-500 transition">Software</Link>
        <Link to="/services/maintenance" className="hover:text-gray-500 transition">Maintenance</Link>
        <Link to="/faq" className="hover:text-gray-500 transition">FAQ</Link>
        <Link to="/contact" className="hover:text-gray-500 transition">Contact</Link>
      </nav>

      {/* Right Side - Dark/Light Mode Toggle & Mobile Menu */}
      <div className="flex items-center space-x-4">
        {/* Dark/Light Mode Toggle (Always Visible) */}
        <button
          onClick={toggleDarkMode}
          className="bg-gray-700 dark:bg-gray-600 hover:bg-gray-600 dark:hover:bg-gray-500 text-white p-3 rounded-full"
        >
          {darkMode ? <BsSun size={20} className="text-yellow-500" /> : <BsMoon size={20} className="text-blue-300" />}
        </button>

        {/* Mobile Menu Button */}
        <button className="md:hidden" onClick={() => setMobileMenuOpen(!mobileMenuOpen)}>
          {mobileMenuOpen ? <FiX size={30} className="text-white" /> : <FiMenu size={30} className="text-grey" />}
        </button>
      </div>

      {/* Mobile Sidebar (ONLY "Fries" Underline Effect, NO Background Hover) */}
      <AnimatePresence>
        {mobileMenuOpen && (
          <motion.aside
            className="absolute top-[65px] right-0 w-full sm:w-[60%] bg-white dark:bg-[#1c1c1c] shadow-lg rounded-xl p-6 text-center"
            initial={{ opacity: 0, x: 100 }}
            animate={{ opacity: 1, x: 0 }}
            exit={{ opacity: 0, x: 100 }}
            transition={{ duration: 0.3 }}
          >
            {/* Mobile Nav Links */}
            <ul className="text-gray-800 dark:text-white space-y-4">
              {[
                { name: "Our Process", path: "/our-process" },
                { name: "Websites", path: "/services/websites" },
                { name: "Software", path: "/services/software" },
                { name: "Maintenance", path: "/services/maintenance" },
                { name: "FAQ", path: "/faq" },
                { name: "Contact", path: "/contact" },
              ].map((item, index) => (
                <li key={index} className="relative group cursor-pointer">
                  <Link
                    to={item.path}
                    className="py-2 px-4 block transition"
                  >
                    {item.name}
                  </Link>
                  {/* Fries Underline Effect on Hover */}
                  <div className="absolute left-0 bottom-0 h-1 bg-[#e5471f] w-0 group-hover:w-full transition-all duration-300 rounded-full"></div>
                </li>
              ))}
            </ul>
          </motion.aside>
        )}
      </AnimatePresence>
    </motion.nav>
  );
};

export default Header;


